module.exports = __webpack_public_path__ + "static/img/recharge_fail.365db10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recharge_fail.png
// module id = t3wh
// module chunks = 1